import firebase from './Firebase';

let domain = window.location.href.replace(/^(http?s:\/\/[^/]+).*$/, '$1');
let api_url = process.env.REACT_APP_PROOFREAD_API_ENDPOINT.startsWith(domain) ? process.env.REACT_APP_PROOFREAD_API_ENDPOINT : process.env.REACT_APP_PROOFREAD_API_ENDPOINT_2;

export default class PRAPI {

  static sessionPost = async(formdata, type) => {
    const idToken = await PRAPI.getIdToken();
    return new Promise((resolve, reject)=>{
      //formdata.append('signType', PRAPI.getSignType());
      formdata.append('idToken', idToken);
      let xhr = new XMLHttpRequest();
      xhr.open('post', api_url, true);
      xhr.withCredentials = true;
      xhr.responseType = type;
      xhr.onload = function() {
        if (xhr.status === 200) resolve(xhr.response);
        else reject(xhr.statusText);
      }
      xhr.send(formdata);
    });
  }

  static getSignType = () => {
    let sign = document.location.pathname.replace(/\/proofread\/?/, '');
    if (sign.match(/^\d{9}$/)) return 'customer';
    else if (sign.length === 32) return 'school';
    return null;
  }

  static async getIdToken() {
    let target = window.location.pathname.replace(/\/proofread\/?/, '');
    if (target.match(/^\d{14}$/)) target = target.slice(0,9);
    if (!target.match(/^\d{9}$/)) return null;
    let auth = firebase.auth();
    if (!auth.currentUser) return null;
    return await auth.currentUser.getIdToken(false);
  }

  // ログイン UrlUser
  static isSignonUrl = async(sign) => {
    let formdata = new FormData();
    formdata.append('method', 'isSignonUrl');
    formdata.append('sign', sign);
    return PRAPI.sessionPost(formdata, 'json');
  }
  static signonUrl = async(sign, password) => {
    let formdata = new FormData();
    formdata.append('method', 'signonUrl');
    formdata.append('sign', sign);
    formdata.append('password', password);
    return PRAPI.sessionPost(formdata, 'json');
  }

  // オンライン校正 アルバム情報、ページリストの取得
  static load = async(oriuq) => {
    let formdata = new FormData();
    formdata.append('method', 'load_v2');
    formdata.append('oriuq', oriuq);
    return PRAPI.sessionPost(formdata, 'json');
  }
  // オンライン校正 プレビュー画像 校正出し日
  static getPreview = async(uuid, oriuq, koseiStart, doOpen) => {
    const idToken = await PRAPI.getIdToken();
    let formdata = new FormData();
    formdata.append('method', 'getPreview');
    formdata.append('idToken', idToken);
    formdata.append('data', JSON.stringify({
      oriuq: oriuq,
      uuid: uuid,
      koseiStart: koseiStart,
      doOpen: doOpen,
    }));
    return new Promise((resolve, reject)=>{
      let xhr = new XMLHttpRequest();
      xhr.open('post', api_url, true);
      xhr.withCredentials = true;
      xhr.responseType = 'blob';
      xhr.onload = function() {
        if (xhr.status === 200) {
          var filename = getFilename(xhr);
          var openedError = xhr.getResponseHeader('OpenedError');
          if (filename) {
            resolve({blob:xhr.response, filename:filename, error:openedError});
          }
          else {
            reject('cannot get Content-Disposition');
          }
        }
        else reject(xhr.statusText);
      }
      xhr.send(formdata);
    });

    function getFilename(xhr) {
      var disposition = xhr.getResponseHeader('Content-Disposition');
      if (!disposition) return null;
      let segments = disposition.split(';');
      if (segments.length < 2) return null;
      if (!segments[1].trim().match(/^filename=/)) return null;
      return segments[1].trim().replace(/^filename=/,'').replace(/^"|"$/g,'');
    }
  }
  // オンライン校正 プレビュー画像 ファイル名
  static getPreviewWithFilename = async(oriuq, filename) => {
    let formdata = new FormData();
    formdata.append('method', 'getPreviewWithFilename');
    formdata.append('oriuq', oriuq);
    formdata.append('filename', filename);
    return PRAPI.sessionPost(formdata, 'blob');
  }
  static getDirectionPreviewWithFilename = async(oriuq, filename) => {
    let formdata = new FormData();
    formdata.append('method', 'getDirectionPreviewWithFilename');
    formdata.append('oriuq', oriuq);
    formdata.append('filename', filename);
    return PRAPI.sessionPost(formdata, 'blob');
  }
  // オンライン校正 アップロード
  static uploadPhoto = async(oriuq, file) => {
    let formdata = new FormData();
    formdata.append('method', 'uploadPhoto');
    formdata.append('oriuq', oriuq);
    formdata.append('file', file);
    return PRAPI.sessionPost(formdata, 'json');
  }
  static deletePhotos = async(oriuq, photoUniques) => {
    let formdata = new FormData();
    formdata.append('method', 'deletePhotos');
    formdata.append('oriuq', oriuq);
    formdata.append('photoUniques', JSON.stringify(photoUniques));
    return PRAPI.sessionPost(formdata, 'json');
  }
  static loadPhotos = async(oriuq) => {
    let formdata = new FormData();
    formdata.append('method', 'loadPhotos');
    formdata.append('oriuq', oriuq);
    return PRAPI.sessionPost(formdata, 'json');
  }
  static saveDirection = async (oriuq, data, preview) => {
    let formdata = new FormData();
    formdata.append('method', 'saveDirection');
    formdata.append('oriuq', oriuq);
    let d = new Date();
    let dateText = d.getFullYear() + ('00'+(d.getMonth()+1)).slice(-2) + ('00'+d.getDate()).slice(-2)
      + '.'
      + ('00'+d.getHours()).slice(-2) + ('00'+d.getMinutes()).slice(-2) + ('00'+d.getSeconds()).slice(-2)
      + '.'
      + ('000'+d.getMilliseconds()).slice(-3);
    let json = JSON.stringify(data);
    let jsonFile = new File([json], dateText+'.json', {type: "application/json", lastModified: d})
    formdata.append('file', jsonFile);
    formdata.append('preview', preview);
    return PRAPI.sessionPost(formdata, 'json');
  }
  static getNewestDirection = async (browserUUID, oriuq, koseiStart, doOpen) => {
    let formdata = new FormData();
    formdata.append('method', 'getNewestDirection_v2');
    formdata.append('uuid', browserUUID);
    formdata.append('oriuq', oriuq);
    formdata.append('koseiStart', koseiStart);
    formdata.append('doOpen', doOpen);
    return PRAPI.sessionPost(formdata, 'json');
  }
  static getOldDirection = async (oriuq, filename) => {
    let formdata = new FormData();
    formdata.append('method', 'getOldDirection');
    formdata.append('oriuq', oriuq);
    formdata.append('filename', filename);
    return PRAPI.sessionPost(formdata, 'json');
  }
  // オープン状態の更新
  static open = async(browserUUID, oriuq, koseiStart) => {
    let formdata = new FormData();
    formdata.append('method', 'open');
    formdata.append('uuid', browserUUID);
    formdata.append('oriuq', oriuq);
    formdata.append('koseiStart', koseiStart);
    return PRAPI.sessionPost(formdata, 'json');
  }
  static checkStatus = async(browserUUID, oriuq, koseiStart) => {
    let formdata = new FormData();
    formdata.append('method', 'checkStatus');
    formdata.append('uuid', browserUUID);
    formdata.append('oriuq', oriuq);
    formdata.append('koseiStart', koseiStart);
    return PRAPI.sessionPost(formdata, 'json');
  }
  // クローズ
  static close = async(browserUUID, oriuq) => {
    let formdata = new FormData();
    formdata.append('method', 'close');
    formdata.append('uuid', browserUUID);
    formdata.append('oriuq', oriuq);
    return PRAPI.sessionPost(formdata, 'json');
  }

  // 履歴
  static loadHistories = async(oriuq) => {
    let formdata = new FormData();
    formdata.append('method', 'loadHistories');
    formdata.append('oriuq', oriuq);
    return PRAPI.sessionPost(formdata, 'json');
  }

  // アクセスアカウント
  static addUrlAccount = async(data) => {
    let formdata = new FormData();
    formdata.append('method', 'addUrlAccount');
    formdata.append('data', JSON.stringify(data));
    return PRAPI.sessionPost(formdata, 'json');
  }
  static updateUrlAccount = async(data) => {
    let formdata = new FormData();
    formdata.append('method', 'updateUrlAccount');
    formdata.append('data', JSON.stringify(data));
    return PRAPI.sessionPost(formdata, 'json');
  }
  static deleteUrlAccount = async(data) => {
    let formdata = new FormData();
    formdata.append('method', 'deleteUrlAccount');
    formdata.append('data', JSON.stringify(data));
    return PRAPI.sessionPost(formdata, 'json');
  }
  static loadUrlAccounts = async(albumCode) => {
    let formdata = new FormData();
    formdata.append('method', 'loadUrlAccounts');
    formdata.append('albumCode', albumCode);
    return PRAPI.sessionPost(formdata, 'json');
  }

  // 写真館確認終了
  static customerFinish = async(oriuq, koseiStart, finishType, receiveMail) => {
    let formdata = new FormData();
    formdata.append('method', 'customerFinish');
    formdata.append('oriuq', oriuq);
    formdata.append('koseiStart', koseiStart);
    formdata.append('finishType', finishType);
    formdata.append('receiveMail', receiveMail);
    return PRAPI.sessionPost(formdata, 'json');
  }

  // 学校確認終了
  static schoolFinish = async(oriuq, koseiStart) => {
    let formdata = new FormData();
    formdata.append('method', 'schoolFinish');
    formdata.append('oriuq', oriuq);
    formdata.append('koseiStart', koseiStart);
    return PRAPI.sessionPost(formdata, 'json');
  }

  // 学校確認依頼
  static toSchool = async(oriuq, koseiStart) => {
    let formdata = new FormData();
    formdata.append('method', 'toSchool');
    formdata.append('oriuq', oriuq);
    formdata.append('koseiStart', koseiStart);
    return PRAPI.sessionPost(formdata, 'json');
  }

  // ログアウト
  static logout = async() => {
    let formdata = new FormData();
    formdata.append('method', 'logout');
    return PRAPI.sessionPost(formdata, 'text');
  }
}